export interface EventType {
  key: string;
  value: string;
  text: string;
}

export interface ActionType {
  key: string;
  value: string;
  text: string;
  trackingGroup: string;
}

export const eventTypes: EventType[] = [
  {
    key: 'onActionResult',
    value: 'onActionResult',
    text: 'On Action Failure',
  },
  {
    key: 'onExpressConfirmed',
    value: 'onExpressConfirmed',
    text: 'Delivery Confirmed',
  },
  {
    key: 'onFoodDeliveryTime',
    value: 'onFoodDeliveryTime',
    text: 'Order Delivered (time)',
  },
  {
    key: 'onGrabCardApplication',
    value: 'onGrabCardApplication',
    text: 'Virtual Card Application',
  },
  {
    key: 'onPaymentComplete',
    value: 'onPaymentComplete',
    text: 'Payment Complete',
  },
  {
    key: 'onRideCancelledDriver',
    value: 'onRideCancelledDriver',
    text: 'Ride Cancelled by DAX',
  },
  {
    key: 'onBookingCancelledDriver',
    value: 'onBookingCancelledDriver',
    text: 'Booking Cancelled By Driver',
  },
  {
    key: 'onBookingConfirmed',
    value: 'onBookingConfirmed',
    text: 'Booking Confirmed',
  },
  {
    key: 'onGrabCardOrder',
    value: 'onGrabCardOrder',
    text: 'Physical Card Order',
  },
  {
    key: 'onRideDroppingOff',
    value: 'onRideDroppingOff',
    text: 'Ride Pick-up',
  },
  {
    key: 'onVentureWheelsUnlock',
    value: 'onVentureWheelsUnlock',
    text: 'Wheel Unlock',
  },
  {
    key: 'onFoodBookingConfirmed',
    value: 'onFoodBookingConfirmed',
    text: 'Food Booking Confirmed',
  },
  {
    key: 'onGrabCardActivation',
    value: 'onGrabCardActivation',
    text: 'Physical Card Activation',
  },
  {
    key: 'onRewardRedemption',
    value: 'onRewardRedemption',
    text: 'Reward Redemption',
  },
  {
    key: 'onSpringCashoutComplete',
    value: 'onSpringCashoutComplete',
    text: 'Cash out',
  },
  {
    key: 'onVentureWheelsGrade',
    value: 'onVentureWheelsGrade',
    text: 'Wheel Rating',
  },
  {
    key: 'onBookingCancelledPassenger',
    value: 'onBookingCancelledPassenger',
    text: 'Booking Cancelled By passenger',
  },
  {
    key: 'onBookingChargeComplete',
    value: 'onBookingChargeComplete',
    text: 'Booking Charge',
  },
  {
    key: 'onAdClickEvent',
    value: 'onAdClickEvent',
    text: 'Ad Click',
  },
  {
    key: 'onGrabCardChargeComplete',
    value: 'onGrabCardChargeComplete',
    text: 'GrabCard Charge',
  },
  {
    key: 'onFoodOrderCancelledDax',
    value: 'onFoodOrderCancelledDax',
    text: 'Food Order Cancelled by DAX',
  },
  {
    key: 'onFoodPushNotification',
    value: 'onFoodPushNotification',
    text: 'Growth Event',
  },
  {
    key: 'onP2MComplete',
    value: 'onP2MComplete',
    text: 'P2M',
  },
  {
    key: 'onSubscriptionEvent',
    value: 'onSubscriptionEvent',
    text: 'Subscription',
  },
  {
    key: 'onVentureWheelsSpeed',
    value: 'onVentureWheelsSpeed',
    text: 'Wheel Speed',
  },
  {
    key: 'onAdVideoCompleteEvent',
    value: 'onAdVideoCompleteEvent',
    text: 'Ad Video Complete',
  },
  {
    key: 'onBookingComplete',
    value: 'onBookingComplete',
    text: 'Booking Complete',
  },
  {
    key: 'onCreditTopupComplete',
    value: 'onCreditTopupComplete',
    text: 'Credit Topup',
  },
  {
    key: 'onKYCEvent',
    value: 'onKYCEvent',
    text: 'KYC Change',
  },
  {
    key: 'onP2PComplete',
    value: 'onP2PComplete',
    text: 'P2P',
  },
  {
    key: 'onPOISearchEvent',
    value: 'onPOISearchEvent',
    text: 'POI Food Keyword Search',
  },
  {
    key: 'onAppOpenEvent',
    value: 'onAppOpenEvent',
    text: 'App Open',
  },
  {
    key: 'onFoodOrderConfirmedMex',
    value: 'onFoodOrderConfirmedMex',
    text: 'Food Order Confirmed by MEX',
  },
  {
    key: 'onRideCancelledPassenger',
    value: 'onRideCancelledPassenger',
    text: 'Ride Cancelled by PAX',
  },
  {
    key: 'onExpressComplete',
    value: 'onExpressComplete',
    text: 'Delivery Complete',
  },
  {
    key: 'onFoodOrderCancelledPax',
    value: 'onFoodOrderCancelledPax',
    text: 'Food Order Cancelled by PAX',
  },
  {
    key: 'onFoodOrderComplete',
    value: 'onFoodOrderComplete',
    text: 'Food Order Complete',
  },
  {
    key: 'onGrabFormEvent',
    value: 'onGrabFormEvent',
    text: 'Grab Form',
  },
  {
    key: 'onPartnerPayComplete',
    value: 'onPartnerPayComplete',
    text: 'Partner Pay',
  },
  {
    key: 'onRewardUsage',
    value: 'onRewardUsage',
    text: 'Reward Usage (4-digit PIN)',
  },
  {
    key: 'onAdConversionEvent',
    value: 'onAdConversionEvent',
    text: 'Ad Conversion',
  },
  {
    key: 'onDeeplinkOpen',
    value: 'onDeeplinkOpen',
    text: 'Deeplink Open',
  },
  {
    key: 'onRideUnsuccessfulReallocation',
    value: 'onRideUnsuccessfulReallocation',
    text: 'Ride Unsuccessful Reallocation',
  },
  {
    key: 'onUsagePercentEvent',
    value: 'onUsagePercentEvent',
    text: 'On Usage Percent Update',
  },
  {
    key: 'onFoodOrderConfirmedDax',
    value: 'onFoodOrderConfirmedDax',
    text: 'Food Order Confirmed by DAX',
  },
  {
    key: 'onGPDMEvent',
    value: 'onGPDMEvent',
    text: 'Digital Marketplace',
  },
  {
    key: 'onRideComplete',
    value: 'onRideComplete',
    text: 'Ride Complete',
  },
  {
    key: 'onUnsuccessfulReallocation',
    value: 'onUnsuccessfulReallocation',
    text: 'Booking Unsuccessful Reallocation',
  },
  {
    key: 'onAdVideoPlayEvent',
    value: 'onAdVideoPlayEvent',
    text: 'Ad Video Play',
  },
  {
    key: 'onAdViewEvent',
    value: 'onAdViewEvent',
    text: 'Ad View',
  },
  {
    key: 'onGrabCardCreate',
    value: 'onGrabCardCreate',
    text: 'Virtual Card Creation',
  },
  {
    key: 'onUsageCountEvent',
    value: 'onUsageCountEvent',
    text: 'On Usage Count Update',
  },
  {
    key: 'onVentureWheelsLock',
    value: 'onVentureWheelsLock',
    text: 'Wheel Lock',
  },
  {
    key: 'onFoodOrderUnallocated',
    value: 'onFoodOrderUnallocated',
    text: 'Food Order Unallocated',
  },
  {
    key: 'onRideConfirmed',
    value: 'onRideConfirmed',
    text: 'Ride Confirmed',
  },
  {
    key: 'onTierEvent',
    value: 'onTierEvent',
    text: 'GrabRewards Tier Change',
  },
];

export const actionTypes: ActionType[] = [
  {
    key: 'awardSubscription',
    value: 'awardSubscription',
    text: 'Award Subscription',
    trackingGroup: 'trident',
  },
  {
    key: 'awardNFT',
    value: 'awardNFT',
    text: 'Award NFT',
    trackingGroup: 'trident',
  },
  {
    key: 'bulkPushChainedInbox',
    value: 'bulkPushChainedInbox',
    text: 'Bulk Push Chained Inbox',
    trackingGroup: 'comms',
  },
  {
    key: 'bulkSendInbox',
    value: 'bulkSendInbox',
    text: 'Bulk Send Inbox',
    trackingGroup: 'comms',
  },
  {
    key: 'sendPush',
    value: 'sendPush',
    text: 'Send Push',
    trackingGroup: 'comms',
  },
  {
    key: 'updateDaxGroupMembership',
    value: 'updateDaxGroupMembership',
    text: 'Update Dax Group Membership',
    trackingGroup: 'trident',
  },
  {
    key: 'updateSegmentMembership',
    value: 'updateSegmentMembership',
    text: 'Update Segment Membership',
    trackingGroup: 'trident',
  },
  {
    key: 'awardReward',
    value: 'awardReward',
    text: 'Award Reward',
    trackingGroup: 'trident',
  },
  {
    key: 'bulkSendEmail',
    value: 'bulkSendEmail',
    text: 'Bulk Send Email',
    trackingGroup: 'comms',
  },
  {
    key: 'bulkSendEmailByAddress',
    value: 'bulkSendEmailByAddress',
    text: 'Bulk Send Email By Address',
    trackingGroup: 'comms',
  },
  {
    key: 'sendEmail',
    value: 'sendEmail',
    text: 'Send Email',
    trackingGroup: 'comms',
  },
  {
    key: 'sendInbox2',
    value: 'sendInbox2',
    text: 'Send Inbox',
    trackingGroup: 'comms',
  },
  {
    key: 'sendSlack',
    value: 'sendSlack',
    text: 'Send Slack',
    trackingGroup: 'trident',
  },
  {
    key: 'updateQuest',
    value: 'updateQuest',
    text: 'Update Quest',
    trackingGroup: 'trident',
  },
  {
    key: 'awardPoint',
    value: 'awardPoint',
    text: 'Award Point',
    trackingGroup: 'trident',
  },
  {
    key: 'awardPromo',
    value: 'awardPromo',
    text: 'Award Promo',
    trackingGroup: 'trident',
  },
  {
    key: 'inboxAndPush',
    value: 'inboxAndPush',
    text: 'Send Inbox and Push (Deprecated)',
    trackingGroup: 'comms',
  },
  {
    key: 'pushChainedInbox',
    value: 'pushChainedInbox',
    text: 'Push Chained Inbox',
    trackingGroup: 'comms',
  },
  {
    key: 'bulkAwardReward',
    value: 'bulkAwardReward',
    text: 'Bulk Award Reward',
    trackingGroup: 'trident',
  },
  {
    key: 'bulkSendPush',
    value: 'bulkSendPush',
    text: 'Bulk Send Push',
    trackingGroup: 'comms',
  },
  {
    key: 'sendGrabChat',
    value: 'sendGrabChat',
    text: 'Send GrabChat',
    trackingGroup: 'comms',
  },
];

export const nodeTypes = {
  scenarios: 'scenarios',
  time: 'time',
  schedule: 'schedule',
  enumeration: 'enumeration',
  delay: 'delay',
  experiment: 'experiment',
  experimentTreatment: 'experimentTreatment',
  count: 'count',
  countCondition: 'countCondition',
  condition: 'condition',
  actions: 'actions',
  action: 'action',
  randomizer: 'randomizer',
} as const;

export const startingNodeTypes = [
  nodeTypes.scenarios,
  nodeTypes.time,
  nodeTypes.schedule,
];

export const targetUserTypes = {
  pax: 'passenger',
  moveITPax: 'moveit_passenger',
  dax: 'driver',
  moveITDax: 'moveit_driver',
  mex: 'foodmax',
  treatment: 'treatment',
  userservice: 'userservice',
  ovo: 'ovo',
} as const;

export const ownerTypes = {
  targeting: 'TARGETING',
  quest: 'quest',
} as const;

export const campaignChangeTypes = {
  create: 'create',
  update: 'update',
  patch: 'patch',
  activate: 'activate',
  deactivate: 'deactivate',
  requestApproval: 'requestApproval',
  rejectApproval: 'rejectApproval',
  withdraw: 'backDraft',
} as const;

export const changeTypeToAuditResourceType: Record<string, string> = {
  [campaignChangeTypes.create]: 'createCampaign',
  [campaignChangeTypes.update]: 'updateCampaign',
  [campaignChangeTypes.activate]: 'patchCampaign',
  [campaignChangeTypes.deactivate]: 'patchCampaign',
};

// Type definitions for better type safety
export type NodeType = keyof typeof nodeTypes;
export type StartingNodeType = typeof startingNodeTypes[number];
export type TargetUserType = keyof typeof targetUserTypes;
export type OwnerType = keyof typeof ownerTypes;
export type CampaignChangeType = keyof typeof campaignChangeTypes;
